module.exports = __webpack_public_path__ + "img/settingsblk.d08b2884.svg";